import type { MemberMapTableColumns } from '@library/types/memberProfileMap';
import type { TableColumn } from '@library/types/utils';

export const colWidth = 'w-[12.5%]';

export const MEMBER_COMMON_COORDS_HEADERS: Array<
  TableColumn<MemberMapTableColumns>
> = [
  {
    column: 'ip_address',
    essential: true,
    label: 'IP address',
    sortEnabled: false,
    width: 'w-[15%]'
  },
  {
    column: 'latitude',
    essential: true,
    label: 'Latitude',
    sortEnabled: false,
    width: 'w-[10%]'
  },
  {
    column: 'longitude',
    essential: true,
    label: 'Longitude',
    sortEnabled: false,
    width: colWidth
  },
  {
    column: 'city',
    essential: true,
    label: 'City',
    sortEnabled: false,
    width: colWidth
  },
  {
    column: 'state',
    essential: true,
    label: 'State',
    sortEnabled: false,
    width: colWidth
  },
  {
    column: 'country',
    essential: true,
    label: 'Country',
    sortEnabled: false,
    width: colWidth
  }
];
